import { render, staticRenderFns } from "./overdue-password.vue?vue&type=template&id=761c1322&scoped=true"
import script from "./overdue-password.vue?vue&type=script&lang=js"
export * from "./overdue-password.vue?vue&type=script&lang=js"
import style0 from "./overdue-password.vue?vue&type=style&index=0&id=761c1322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761c1322",
  null
  
)

export default component.exports